import { apiClient } from './authenticatedApiClient';
import { AppSingletonPromise } from './AppSingletonPromise';
import { IGebruiker } from '@/model/IGebruiker';
import { VoorkeurenNotificaties } from '@/model/VoorkeurenNotificaties';

class AppGebruikerService {
  @AppSingletonPromise
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public getGebruiker(force = false): Promise<IGebruiker> {
    return apiClient.get<IGebruiker>('Gebruikers/').then(response => {
      return response.data;
    });
  }

  public updateEmail(email: string): Promise<void> {
    return apiClient.post('Gebruikers/updateEmail',  "\"" + email + "\"");
  }

  public updateTelefoonnummer(telefoonnummer: string): Promise<void> {
    return apiClient.post('Gebruikers/updateTelefoonnummer', "\"" + telefoonnummer + "\"");
  }

  public updateVoorkeurNotificaties(voorkeurNotificaties: VoorkeurenNotificaties | undefined): Promise<void> {
    return apiClient.put('Gebruikers/updateVoorkeurNotificaties', 
      VoorkeurenNotificaties[voorkeurNotificaties ?? VoorkeurenNotificaties.Geen]
    );
  } 
  }

export const appGebruikerService = new AppGebruikerService();
